// "Just created (N)" chip — first chip in a workspace list's filter row when SAM filtered the list
// to the records it just created (multi-create FILTER_CREATED). Clicking it clears the id filter.
// Brand-tinted (not a preset chip) so it reads as a temporary filter SAM applied.
import React from 'react';
import { useTranslation } from 'react-i18next';

interface CreatedIdsChipProps {
  count: number;
  /** i18n key for the tooltip, e.g. `workspaceCreated.showAllTasks`. */
  titleKey: string;
  onClear: () => void;
}

export const CreatedIdsChip: React.FC<CreatedIdsChipProps> = ({ count, titleKey, onClear }) => {
  const { t } = useTranslation();
  if (count <= 0) return null;
  return (
    <button
      type="button"
      onClick={onClear}
      className="flex-shrink-0 flex items-center gap-1.5 whitespace-nowrap rounded-full border border-brand-dark/30 bg-brand-dark/5 px-2.5 py-1 text-[11px] font-medium text-ui-text hover:bg-brand-dark/10"
      title={t(titleKey)}
    >
        {t('workspaceCreated.justCreated', { count })}
        <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true">
          <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
      </svg>
    </button>
  );
};

export default CreatedIdsChip;
